<template>
  <div v-if="expressCheckoutAvailable" class="apple-pay">
    <ApplePayButton
      :class="buttonClasses"
      :onClick="startApplePayExpressCheckout"
      :isLoading="isLoading"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ApplePayButton from './_shared/ButtonApplePay.vue'
import ApplePay from './_shared/apple-pay'
import ApiService from './_shared/api-service'

export default {
  name: 'ApplePayExpressCheckout',
  components: {
    ApplePayButton,
  },
  props: {
    isMiniCart: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters('checkout', [
      'applePayExpressCheckoutRequest',
      'applePayAuthorizePaymentUrl',
      'showApplePayButton',
      'authorizeMerchantsUrl',
      'termsAndConditionsUrl',
      'updateCheckoutAdressUrl',
      'updateCheckoutDeliveryUrl',
      'updateCheckoutRegistrationUrl',
    ]),
    ...mapGetters('page', ['country']),
    expressCheckoutAvailable() {
      return this.showApplePayButton && this.isCountryAllowed
    },
    isCountryAllowed() {
      const allowedCountries = ['ch', 'de', 'at', 'us']
      const currentCountry = this.country.toLowerCase()
      return allowedCountries.includes(currentCountry)
    },
    buttonClasses() {
      return { 'apple-pay-button--mini-cart': this.isMiniCart }
    },
  },
  mounted() {
    document.querySelector('.site-content').classList.add('u-smooth-load--visible')
  },
  methods: {
    startApplePayExpressCheckout() {
      try {
        this.isLoading = true
        const apiService = new ApiService({
          http: this.$http,
          paths: {
            authorizeMerchantsUrl: this.authorizeMerchantsUrl,
            updateCheckoutAdressUrl: this.updateCheckoutAdressUrl,
            updateCheckoutDeliveryUrl: this.updateCheckoutDeliveryUrl,
            updateCheckoutRegistrationUrl: this.updateCheckoutRegistrationUrl,
            applePayAuthorizePaymentUrl: this.applePayAuthorizePaymentUrl,
          },
        })
        const applePay = new ApplePay({
          request: this.applePayExpressCheckoutRequest,
          apiService,
          expressCheckout: true,
          onDone: () => {
            this.isLoading = false
          },
        })
        applePay.beginSession()
      } catch (error) {
        this.isLoading = false
        window.console?.log(`Oops got an error: ${error.message}`)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.fade-payment-enter,
.fade-payment-leave-to {
  opacity: 0;
}

.fade-payment-enter-active,
.fade-payment-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.apple-pay-button {
  margin-top: 0;
  padding: 9px 0;
  height: 48px;

  &--mini-cart {
    .apple-pay-button__inner-container {
      min-width: inherit;
    }
  }
}
</style>
